import { Link } from "@tanstack/react-router";

/**
 * Compact overzicht van verwante pagina's. Zo blijft de hoofdnavigatie en de
 * footer rustig: de detailpagina's zijn te vinden via hun eigen onderwerp.
 */
export function LinkHub({
  title,
  links,
}: {
  title: string;
  links: readonly { to: string; label: string; description?: string }[];
}) {
  return (
    <section className="card-elevated p-5 sm:p-6">
      <h2 className="font-display text-lg font-bold">{title}</h2>
      <ul className="mt-3 grid gap-2 sm:grid-cols-2">
        {links.map((link) => (
          <li key={link.to}>
            <Link
              to={link.to as never}
              className="block rounded-lg border border-border px-3 py-2.5 transition-colors hover:border-primary hover:bg-secondary/60"
            >
              <span className="text-sm font-semibold text-foreground">{link.label}</span>
              {link.description && (
                <span className="mt-0.5 block text-xs text-muted-foreground">
                  {link.description}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
